const appointmentAnalytics = 'appointment-analytics';

export const trackingIds = {
  chartsView: `${appointmentAnalytics}-charts-view-tab`,
  clearFilters: `${appointmentAnalytics}-clear-filters`,
  downloadMain: `${appointmentAnalytics}-download-main`,
  filtersOpen: `${appointmentAnalytics}-filters-open`,
  filtersOpenUpcoming: `${appointmentAnalytics}-filters-open-upcoming`,
  filtersOpenPast: `${appointmentAnalytics}-filters-open-past`,
  helpVideo: `${appointmentAnalytics}-help-video`,
  tableView: `${appointmentAnalytics}-table-view-tab`,
  filterTrayToggle: `${appointmentAnalytics}-filter-tray-toggle`,
  filterTrayApply: `${appointmentAnalytics}-filter-tray-apply`,
  filterTrayCancel: `${appointmentAnalytics}-filter-tray-cancel`,
  filterTrayClearAll: `${appointmentAnalytics}-filter-tray-clear-all`,
} as const;
